import { FC } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

interface IProps {
  customScrollProps: {
    handleThumbDrag: (event: any) => void;
    customScrollRef: React.RefObject<HTMLDivElement>;
    customScrollThumbsRef: React.RefObject<HTMLDivElement>;
    scrollHeight: number;
  };
  sxScroll?: SxProps<Theme>;
  sxThumb?: SxProps<Theme>;
}

export const CustomScrollbar: FC<IProps> = ({ customScrollProps, sxScroll, sxThumb }) => {
  const { handleThumbDrag, customScrollRef, customScrollThumbsRef } = customScrollProps;
  return (
    <Box
      ref={customScrollRef}
      sx={{
        width: '8px',
        height: 'calc(100% - 72px)',
        position: 'absolute',
        top: '66px',
        right: '5px',
        ...sxScroll
      }}>
      <Box
        ref={customScrollThumbsRef}
        sx={{
          width: '100%',
          background: 'var(--mui-palette-customScrollbar-thumb)', //paletteScroll
          borderRadius: '16px',
          position: 'absolute',
          cursor: 'pointer',
          top: '0',
          height: `${customScrollProps.scrollHeight}% !important`, // Initial height
          ...sxThumb
        }}
        onMouseDown={handleThumbDrag}
      />
    </Box>
  );
};
